import { ClipboardList, Compass, HelpCircle, LockKeyhole, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
import { GuestSignInLink } from '@components/auth/GuestSignInLink';
import { PageShell, Surface } from '@components/system';

const guestDestinations = [
  {
    path: '/recruitments',
    title: '翻阅招募板',
    description: '查看公开团务、题材、时间与安全边界。联系方式仍按发布者设定显示。',
    icon: ClipboardList,
  },
  {
    path: '/forums',
    title: '聆听旧日低语',
    description: '浏览公开分卷、主题与回声；发帖、回复和点赞需要正式身份。',
    icon: MessageSquare,
  },
  {
    path: '/help',
    title: '查看城市手册',
    description: '了解沉没之城的跑团流程、功能边界和常见问题。',
    icon: HelpCircle,
  },
];

export function GuestHomePage() {
  return (
    <PageShell
      eyebrow="VISITOR PASS"
      title="沿海岸线参观沉没之城"
      description="游客身份不会创建账号或加入任何房间。你可以安全浏览公开卷宗，决定是否接受召唤。"
      actions={
        <GuestSignInLink className="btn-v2 coc-btn-primary guest-home__signin">
          接受召唤并登录
        </GuestSignInLink>
      }
      aside={
        <Surface variant="panel" material="archive" padding="md" className="guest-home__boundary">
          <div className="guest-home__boundary-title">
            <LockKeyhole size={17} />
            游客边界
          </div>
          <p>只开放公开读取。角色、房间、私信、资产、小游戏及所有写入操作均保持封存。</p>
        </Surface>
      }
      className="guest-home"
    >
      <Surface variant="solid" tone="gold" material="archive" padding="lg" className="guest-home__welcome">
        <span className="guest-home__sigil" aria-hidden="true"><Compass size={28} /></span>
        <div>
          <div className="guest-home__kicker">临时访客通行证已生效</div>
          <h2>潮雾之外，公开档案正在显影</h2>
          <p>从招募、论坛或城市手册开始。遇到需要身份的入口时，系统会明确提示登录，不会代替你创建任何数据。</p>
        </div>
      </Surface>

      <div className="guest-home__destinations">
        {guestDestinations.map(({ path, title, description, icon: Icon }) => (
          <Link key={path} to={path} className="guest-home__destination">
            <Surface variant="panel" material="archive" padding="lg" interactive>
              <span className="guest-home__destination-icon" aria-hidden="true"><Icon size={22} /></span>
              <h2>{title}</h2>
              <p>{description}</p>
              <span className="guest-home__destination-action">进入公开区域 →</span>
            </Surface>
          </Link>
        ))}
      </div>
    </PageShell>
  );
}
